/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProcessInvoiceTransactionError
 */
export interface ProcessInvoiceTransactionError {
    /**
     * 
     * @type {string}
     * @memberof ProcessInvoiceTransactionError
     */
    transactionId: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessInvoiceTransactionError
     */
    error: string;
}

/**
 * Check if a given object implements the ProcessInvoiceTransactionError interface.
 */
// @ts-ignore
export function instanceOfProcessInvoiceTransactionError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "transactionId" in value;
    isInstance = isInstance && "error" in value;

    return isInstance;
}

// @ts-ignore
export function ProcessInvoiceTransactionErrorFromJSON(json: any): ProcessInvoiceTransactionError {
    return ProcessInvoiceTransactionErrorFromJSONTyped(json, false);
}

// @ts-ignore
export function ProcessInvoiceTransactionErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessInvoiceTransactionError {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionId': json['transaction_id'],
        'error': json['error'],
    };
}

// @ts-ignore
export function ProcessInvoiceTransactionErrorToJSON(value?: ProcessInvoiceTransactionError | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transaction_id': value.transactionId,
        'error': value.error,
    };
}

